import { z } from 'zod/v4-mini';
import { queryProcedure } from '../trpc/common.js';
import type { ApiParams } from '../types/ApiParams.js';
import { matchingZodObject } from '../utilities/matchingZodObject.js';

export interface GetDataInput {
  /** Path array from the data bus source */
  path: string[];
}

export const ZodGetDataInput = matchingZodObject<GetDataInput>({
  path: z.array(z.string()),
});

export function getData(params: ApiParams<GetDataInput, 'bus'>): unknown {
  const {
    input: { path },
    ctx: { bus },
  } = params;

  return bus.getData(path);
}

// Attach a trpc procedure to the function.
getData.procedure = queryProcedure<GetDataInput, unknown>(getData, ZodGetDataInput, z.unknown());
